module.exports = __webpack_public_path__ + "assets/img/29_257_big.40c381b4.jpg";